import axios from "./axiosConfig";

// Initialize from sessionStorage to persist across route changes and page refreshes
const getLoggedInState = () => {
	if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
		return false;
	}
	const stored = sessionStorage.getItem('isLoggedIn');
	return stored === 'true';
};

let isLoggedIn = getLoggedInState();

// Helper function to update both variable and sessionStorage
const setLoggedInState = (value) => {
	isLoggedIn = value;
	if (typeof sessionStorage !== 'undefined') {
		sessionStorage.setItem('isLoggedIn', value.toString());
	}
};

export async function LogInAsAdmin(phone, password) {
	try {
		const response = await axios.post(
			`/login?username=${encodeURIComponent(phone)}&password=${encodeURIComponent(password)}`
		);
		const roles = response.data?.roles || '';
		if (!roles.includes('ADMIN')) {
			setLoggedInState(false);
			console.error('Logged in user is not an admin:', roles);
			return { success: false, error: 'This account does not have admin access.' };
		}
		setLoggedInState(true);
		return { success: true };
	} catch (error) {
		setLoggedInState(false);
		console.error('Failed to sign in:', error);
		const status = error?.response?.status;
		if (status === 401 || status === 403) {
			return { success: false, error: 'Invalid phone number or password.' };
		}
		if (status === 504) {
			return {
				success: false,
				error: 'API timed out. Restart the dev server (npm run dev) and try again.',
			};
		}
		if (!error?.response) {
			return { success: false, error: 'Cannot reach the API. Check your network connection.' };
		}
		return { success: false, error: `Login failed (HTTP ${status}).` };
	}
}

export function checkLoggedIn(){
    // Always check sessionStorage to ensure consistency and sync the variable
    const state = getLoggedInState();
    isLoggedIn = state;
    return state;
}

export async function logout(){
    try {
        const response = await axios.post('/logout');
        if (response.status === 200) {
            setLoggedInState(false);
            sessionStorage.removeItem('isLoggedIn');
            window.location.href = "/login";
        } else {
            throw new Error("Failed to sign out");
        }
    } catch (error) {
        console.log('Failed to sign out:', error);
    }
}